import React from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./sendConceptsForm.data.form";
import InputText from "../../../utils/InputText";
import { HOUR_TYPES } from "../../../../constants";
import InputDate from "../../../utils/InputDate";

const ConceptForm = (props) => {
  const { t } = useTranslation();
  const { handleSubmit, data, onback, isMultiple, selectedNames } = props;

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <h3 className="title">
            {t("forms.workingPartDetail.messages.concepts.title")}
          </h3>
        </div>
      </div>
      {/* <BreadCrumb items={breads} /> */}
      <div className="row justify-content-center  ">
        <div className="col-12 col-md-11">
          <form autoComplete="off" onSubmit={handleSubmit}>
            {!isMultiple && (
              <>
                {data &&
                  data.items &&
                  data.items.map((item, index) => (
                    <div key={item.nifSociety} className="mb-2">
                      <div className="row mt-3">
                        <div className="col-12 justify-content-center">
                          <h5 className="mb-3 text-center">
                            {item.societyName}
                          </h5>
                        </div>
                      </div>
                      {Object.entries(item.hoursByType).map(([type, hours]) => {
                        const typeInfo = HOUR_TYPES.find(
                          (ht) => ht.code === parseInt(type),
                        );
                        const typeName = typeInfo
                          ? t(typeInfo.label)
                          : `Tipo ${type}`;
                        const fieldName = `${item.nifSociety}_${type}`;
                        return (
                          <div className="row mt-2" key={fieldName}>
                            <div className="col-12 ms-3 d-flex align-items-center justify-content-center">
                              <div className="col-3 ">{typeName}</div>
                              <div className="col-1">
                                <Field
                                  id={fieldName}
                                  className="form-control"
                                  // labelField={`${typeName}`}
                                  name={fieldName}
                                  placeholder=""
                                  component={InputText}
                                  fieldType="number"
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ))}
              </>
            )}
            {isMultiple && selectedNames?.length > 0 && (
              <div className="row mt-3 justify-content-center mb-4">
                <div className="col-12 col-md-11">
                  <h5 className="mb-3 text-center">
                    {t(
                      "forms.workingPartDetail.messages.concepts.selectedEmployees",
                    )}
                    :
                  </h5>
                  <div
                    style={{
                      maxHeight: "200px",
                      overflowY: "auto",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      padding: "10px",
                    }}
                  >
                    <ul
                      style={{ listStyleType: "none", padding: 0, margin: 0 }}
                    >
                      {selectedNames.map((employee) => (
                        <li
                          style={{
                            padding: "4px 12px",
                            fontSize: "12px",
                            // borderBottom: '1px solid #eee'
                          }}
                        >
                          {employee.employeeName}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )}
            <div className="row justify-content-center">
              <div className="col-12 col-md-11 ">
                <Field
                  id="dateSend"
                  labelField={t("forms.workingPartDetail.labels.dateSend")}
                  className="form-control"
                  name="dateSend"
                  component={InputDate}
                  language="es"
                  dateFormat="dd/MM/yyyy"
                  defaultHours={12}
                  defaultMinutes={10}
                />
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-11 text-center mt-5 mb-5">
                <button
                  type="button"
                  onClick={() => onback()}
                  className="btn btn-md btn-secondary me-2"
                >
                  {t("forms.workingPartDetail.messages.concepts.cancelButton")}
                </button>
                <button type="submit" className="btn btn-md btn-primary">
                  {t("forms.workingPartDetail.messages.concepts.confirmButton")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

ConceptForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  // onback: PropTypes.func,
  data: PropTypes.object,
};

const ConceptFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "ConceptForm",
})(ConceptForm);

export default ConceptFormF;
